import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeMedSeq extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    get defaultSerialized() {
        return { ...super.defaultSerialized, value: { type: 'medseq' } };
    }
}
